<template>
   <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="col-lg-12">
         <div class="row">
            <!-- <div class="col-lg-4 col-md-6">
               <div class="card card-block card-stretch card-height">
                  <div class="card-body">
                     <div class="d-flex align-items-center justify-content-between">
                        <div class="mm-cart-text">
                           <p class="mb-0 text-danger">Active Tests</p>
                           <h4 class="font-weight-400">50</h4>
                        </div>
                        <div class="mm-cart-image text-primary" style="height: 52px; width: 50px;">
                           <i class="fa fa-3x fa-hospital"></i>
                        </div>
                     </div>
                  </div>
               </div>
            </div> -->

            <div class="col-md-4">
               <div class="card mini-stats-wid">
                  <div class="card-body">
                     <div class="media mb-3">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2 font-size-18">Bookings</p>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                        <span class="avatar-title">
                           <i class="fas fa-calendar-plus font-size-20"></i>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Today</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ todays_bookings }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This week</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ this_week_bookings }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This month</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ this_month_bookings }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Total</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ total_bookings }}</h4>
                        </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div class="col-md-4">
               <div class="card mini-stats-wid">
                  <div class="card-body">
                     <div class="media mb-3">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2 font-size-18">Counters</p>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                        <span class="avatar-title">
                           <i class="fas fa-3x fa-cash-register"></i>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Today</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ todays_counters }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This week</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ this_week_counters }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This month</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ this_month_counters }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Total</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ total_counters }}</h4>
                        </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div class="col-md-4">
               <div class="card mini-stats-wid">
                  <div class="card-body">
                     <div class="media mb-3">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2 font-size-18">Tvs</p>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                        <span class="avatar-title">
                           <i class="fas fa-3x fa-tv"></i>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Today</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ todays_tvs }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This week</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ this_week_tvs }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media mb-2">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">This month</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ this_month_tvs }}</h4>
                        </span>
                        </div>
                     </div>

                     <div class="media">
                        <div class="media-body">
                        <p class="text-muted fw-medium mb-2">Total</p>
                        </div>

                        <div class="align-self-center ">
                        <span class="float-end me-3">
                           <h4 class="mb-0 font-size-16">{{ total_tvs }}</h4>
                        </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

         </div>
      </div>
      
   </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

// import Stat from "@/components/widgets/stat";

/**
 * Dashboard Component
 */
export default {
   page: {
      title: "Dashboard",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      PageHeader,
    //   Stat,
   },
   data() { 
      return {
         title: "Dashboard",
         items: [
            {
               text: "Dashboard",
               active: true,
            },        
         ],

         todays_bookings: '0',
         this_week_bookings: '0',
         this_month_bookings: '0',
         total_bookings: '0',

         todays_counters: '0',
         this_week_counters: '0',
         this_month_counters: '0',
         total_counters: '0',

         todays_tvs: '0',
         this_week_tvs: '0',
         this_month_tvs: '0',
         total_tvs: '0',

         
      }
   },
   mounted() { },
   created() {
      this.fetchDashboard();
   },

   methods: {
      fetchDashboard() {
         let url = "pharmacy/dashboard";
         this.getToken();
         this.loading = true;
         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var data = res.data.data;
               console.log(data);

               if(data){
                  //Bookings
                  this.todays_bookings = data.todays_bookings;
                  this.this_week_bookings = data.this_week_bookings;
                  this.this_month_bookings = data.this_month_bookings;
                  this.total_bookings = data.total_bookings;

                  this.todays_counters = data.todays_counters;
                  this.this_week_counters = data.this_week_counters;
                  this.this_month_counters = data.this_month_counters;
                  this.total_counters = data.total_counters;

                  this.todays_tvs = data.todays_tvs;
                  this.this_week_tvs = data.this_week_tvs;
                  this.this_month_tvs = data.this_month_tvs;
                  this.total_tvs = data.total_tvs;

               

               }

               

            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));
      },
      getToken() {
         if (localStorage.getItem('medicino_pharmacy')) {
            var medicino_pharmacy = JSON.parse(localStorage.getItem('medicino_pharmacy'));
            if (medicino_pharmacy.token) {
               this.token = medicino_pharmacy.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
   }
}


</script>

